var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5333 24.9667L13.7667 16.2C13.1 16.7778 12.3227 17.2278 11.4347 17.55C10.5467 17.8722 9.60182 18.0333 8.6 18.0333C6.1964 18.0333 4.16217 17.2 2.4973 15.5333C0.832434 13.8667 0 11.8556 0 9.50001C0 7.14445 0.833333 5.13334 2.5 3.46668C4.16667 1.80001 6.18333 0.966675 8.55 0.966675C10.9167 0.966675 12.9278 1.80001 14.5833 3.46668C16.2389 5.13334 17.0667 7.14612 17.0667 9.50501C17.0667 10.4572 16.9111 11.3778 16.6 12.2667C16.2889 13.1556 15.8222 13.9889 15.2 14.7667L24 23.5L22.5333 24.9667ZM8.56667 16.0333C10.3722 16.0333 11.9069 15.3945 13.1708 14.1167C14.4347 12.8389 15.0667 11.3 15.0667 9.50001C15.0667 7.70001 14.4347 6.16112 13.1708 4.88334C11.9069 3.60556 10.3722 2.96667 8.56667 2.96667C6.7426 2.96667 5.19213 3.60556 3.91527 4.88334C2.63842 6.16112 2 7.70001 2 9.50001C2 11.3 2.63842 12.8389 3.91527 14.1167C5.19213 15.3945 6.7426 16.0333 8.56667 16.0333Z",
    fill: "#E5E5E5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.3563535b4b055447c5037ddc21be0bc8.svg";
export { ForwardRef as ReactComponent };